"use client";

import { safeCaptureExceptionFull } from "@/utils/sentry-utils";
import { useEffect, useState, useRef } from "react";
import { extractErrorTrackInfo } from "@/utils/performance-track";
import { track } from "@/utils/track";

const offlineIcon =
  "data:image/png;base64,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";

/**
 * 静态翻译文本
 * 注意：在 global-error 中，我们无法使用 next-intl 的 useTranslations，
 * 因为 root layout 崩溃时，IntlProvider 可能并未正常加载。
 */
const translations: Record<string, { description: string; retry: string; }> = {
  en: {
    description: "Something went wrong, please try again.",
    retry: 'Retry',
  },
  hi: {
    description: 'कुछ गलत हो गया, कृपया पुनः प्रयास करें।',
    retry: 'पुनः प्रयास करें',
  },
  pt: {
    description: 'Algo deu errado, tente novamente.',
    retry: 'Tentar novamente',
  },
  es: {
    description: 'Algo salió mal, intenta de nuevo.',
    retry: 'Reintentar',
  },
  ur: {
    description: 'کچھ غلط ہو گیا، دوبارہ کوشش کریں۔',
    retry: 'دوبارہ کوشش کریں',
  },
};

const SUPPORTED_LOCALES = Object.keys(translations);

/**
 * 收集 Error cause 链路
 * error.cause 可以是另一个 Error，形成链式原因追踪
 * 最多遍历 5 层，防止循环引用导致的死循环
 */
// TypeScript 5.x has a bug where `instanceof Error` on `unknown` narrows to `{}`
// instead of `Error`. Using an explicit type predicate bypasses this issue.
function isError(val: unknown): val is Error {
  return val instanceof Error;
}

function buildCauseChain(err: Error): string | null {
  try {
    const parts: string[] = [];
    const firstCause = (err as Error & { cause?: unknown; }).cause;
    let cause: Error | null = isError(firstCause) ? firstCause : null;
    while (cause !== null && parts.length < 5) {
      parts.push(`${cause.name}: ${cause.message}`);
      const rawNext = (cause as Error & { cause?: unknown; }).cause;
      cause = isError(rawNext) ? rawNext : null;
    }
    return parts.length > 0 ? parts.join(' → ') : null;
  } catch {
    return null;
  }
}

/**
 * 鲁棒的 Locale 检测
 */
function detectLocale(): string {
  if (typeof window === 'undefined') return 'en';

  try {
    // 1. 从 URL 路径获取 (支持 /en 或 /zh-CN)
    const segments = window.location.pathname.split('/');
    const urlLocale = segments[1];
    if (SUPPORTED_LOCALES.includes(urlLocale)) return urlLocale;

    // 2. 从 HTML 根节点获取 (next-intl 渲染时通常会设置)
    const docLang = document.documentElement.lang;
    if (SUPPORTED_LOCALES.includes(docLang)) return docLang;

    // 3. 浏览器语言回退
    if (typeof navigator !== 'undefined') {
      const browserLang = navigator.language.split('-')[0];
      return SUPPORTED_LOCALES.includes(browserLang) ? browserLang : 'en';
    }
    return 'en';
  } catch {
    return 'en';
  }
}

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string; };
  reset: () => void;
}) {
  const [locale, setLocale] = useState('en');
  const [mounted, setMounted] = useState(false);
  const reportedErrorRef = useRef<string | null>(null);

  useEffect(() => {
    setMounted(true);
    const detected = detectLocale();
    setLocale(detected);

    // 避免在重渲染时重复上报同一个错误 (通过 digest 或 message 判断)
    const errorId = error.digest || error.message;
    if (reportedErrorRef.current !== errorId) {
      // 使用 console.warn 而不是 console.error，避免在生产环境中触发 instrumentation 的双重上报
      console.warn('🚨 Global Error Boundary:', error);

      safeCaptureExceptionFull(error, (scope) => {
        scope.setTag('errorBoundary', 'global');
        try {
          if (typeof window !== 'undefined') {
            scope.setTag('routePath', window.location.pathname);
          }
        } catch { /* ignore */ }
        const causeChain = buildCauseChain(error);
        if (causeChain) scope.setExtra('causeChain', causeChain);
        return scope;
      });

      track('js_runtime_error', extractErrorTrackInfo(error));
      reportedErrorRef.current = errorId;
    }
  }, [error]);

  const t = translations[locale] || translations.en;
  const isRTL = locale === 'ur';

  /**
   * 渐进式 retry 策略:
   * - 第 1 次: 调用 reset() 重新渲染
   * - 第 2 次: 清除 Service Worker 缓存后刷新到首页
   * - 第 3 次及以上: 清除所有缓存 + 注销 SW + 刷新到首页
   */
  const handleRetry = () => {
    // 当前页面可能已损坏，跳转到首页
    const locale = window.location.pathname.split('/')[1] || 'en';
    window.location.href = `/${locale}`;
  };

  // 必须返回完整的 HTML 结构，因为 global-error 会替换整个 Root Layout
  // 避免 hydration 不匹配，即使未 mounted 也返回相同结构
  const showContent = mounted;

  return (
    <html lang={showContent ? locale : 'en'} dir={showContent && isRTL ? 'rtl' : 'ltr'}>
      <head>
        <title>Error</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <style>{`
          * { box-sizing: border-box; margin: 0; padding: 0; }
          html, body { height: 100%; background: var(--dark); }
          body {
            font-family: Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            color: white;
          }
          .btn-primary {
            background: #00BBFF;
            box-shadow: inset 0px 2px 2px 0px #39D7FF, inset 0px -2px 0px 0px rgba(0, 114, 180, 0.8);
            color: #FFFFFF;
            text-shadow:
              -1px -1px 0 rgba(0, 129, 195, 0.4),
              1px -1px 0 rgba(0, 129, 195, 0.4),
              -1px 1px 0 rgba(0, 129, 195, 0.4),
              1px 1px 0 rgba(0, 129, 195, 0.4);
            border: none;
            border-radius: 7px;
            padding: 0 15px;
            height: 40px;
            font-weight: 700;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.2s;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
          }
          .btn-primary:active {
            transform: scale(0.90);
          }
          .btn-primary:disabled {
            opacity: 0.35;
            pointer-events: none;
          }
        `}</style>
      </head>
      <body>
        {showContent && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            flexDirection: 'column',
          }}>
            <img
              src={offlineIcon}
              alt="error"
              width={60}
              height={60}
              style={{ marginBottom: '39px' }}
            />
            <p style={{
              fontFamily: 'Montserrat',
              fontWeight: 500,
              fontSize: '12px',
              color: '#748094',
              lineHeight: '15px',
              marginBottom: '33px',
              textAlign: 'center',
              padding: '0 20px',
            }}>
              {t.description}
            </p>
            <button
              onClick={handleRetry}
              className="btn-primary"
              style={{ width: '282px' }}
            >
              {t.retry}
            </button>

            {/* 生产环境下 Digest 对排查问题非常有帮助 */}
            {error.digest && (
              <div style={{
                marginTop: '32px',
                paddingTop: '16px',
              }}>
                <p style={{
                  fontSize: '10px',
                  color: '#444',
                  wordBreak: 'break-all',
                  fontFamily: 'monospace',
                  padding: '0 20px',
                }}>
                  Error ID: {error.digest}
                </p>
              </div>
            )}
          </div>
        )}
      </body>
    </html>
  );
}
